<template>
  <v-container class="d-flex justify-center align-center pt-10">
    <elevated-card
    width="500"
    min-height="780">
      <v-form
      v-model="isFormValid">
        <v-row
        dense
        no-gutters>
          <v-col class="pt-8">
            <div
            class="new-user-title-box d-flex justify-center align-center">
              <v-icon dark class="mr-2">
                mdi-lead-pencil
              </v-icon>
              <span>{{$t('pages.requestAccount.cardTitle')}}</span>
            </div>
          </v-col>
        </v-row>
        <contact-fields
        :first-name.sync="contact.firstName"
        :last-name.sync="contact.lastName"
        :phone.sync="contact.phone"
        :email.sync="contact.email"/>

        <address-fields
        :company-name.sync="address.companyName"
        :country.sync="address.country"
        :province.sync="address.province"
        :city.sync="address.city"
        :postal-code.sync="address.postalCode"
        :street.sync="address.street"
        :building.sync="address.building"/>

        <v-row
        class="mt-8"
        dense
        no-gutters>
          <v-col class="d-flex justify-center align-center pb-4">
            <primary-btn
            @click="tryToCreateNewAccountRequest"
            :disabled="!isFormValid"
            :label="$t('btns.request')"
            :loading="isLoading"
            color='#0277bd'
            :width="150"
            :height="50"
            />
          </v-col>
        </v-row>
      </v-form>
    </elevated-card>
  </v-container>
</template>
<script>
import ElevatedCard from '@/components/cards/ElevatedCard'
import PrimaryBtn from '@/components/btns/PrimaryBtn'
import { execHttpRequestThrowable } from '@/services/http'
import { routeFromRoot } from '@/services/routeService'
import { requestAccount } from '@/repositories/contactRepo'
import ContactFields from '@/components/group-fields/ContactFields.vue'
import AddressFields from '@/components/group-fields/AddressFields'
export default {
  components: {
    ElevatedCard,
    PrimaryBtn,
    ContactFields,
    AddressFields
  },
  data() {
    return {
      contact: {
        id: null,
        firstName: '',
        lastName: '',
        phone: '',
        email: ''
      },
      address: {
        companyName: '',
        country: '',
        province: '',
        city: '',
        postalCode: '',
        street: '',
        building: ''
      },
      isFormValid: false,
      isLoading: false
    }
  },
  computed: {
  },
  methods: {
    async tryToCreateNewAccountRequest() {
      const messages = {
        _200: 'dialogs.messages.success.requestAccountMailSend'
      }

      const data = {
        contact: this.contact,
        address: this.address
      }
      await execHttpRequestThrowable(async () => await requestAccount(data), messages, v => this.isLoading = v)
      routeFromRoot('login')
    }
  },
  mounted() {
    this.$feedback.fill("Create Account Request Page", this.$route.path)
  }
}
</script>
<style>

</style>